import React from 'react';
import './RefundPolicy.css';

import { PageTitle } from '../../../components';

import { Button, Heading } from '../../../components';
import { images } from '../../../constants'; 
import { FaBuilding, FaTools } from 'react-icons/fa';



const RefundPolicy = () => { 
  return ( 
    <>  
      {/* Page title */}
      <PageTitle title={'退款政策'} page={'refund policy'} />
          <section className='refund-policy'>
            
            {/* About section */}
            <section className='about'> 

            <div className='box-container'>

              {/* About images */}
              
      
              {/* About description */}
              <div className='content'> 
                <Heading title={'當發生停車扣款爭議'} subTitle={'退款政策'} />
                <p>為了您的權益，當不幸發生停車繳費綁定支付扣款問題時請詳益閱讀以下條款：</p> {/* Description */}
                <ul className='about-points'> 
                  <li>
                    {/* <FaBuilding className='icon' />  */}
                    {/* Building icon */}
                    <div className='text'>
                      <div className="policyTitle">一、付款流程與確認機制</div> {/* Construction title */}
                      <div className="text-list">
                          <ol>
                            <li>1.本服務將登錄使用者之車牌號碼、駕駛執照、行車執照與車輛照片及支付方法，作為認定會員使用服務的依據。</li>
                            <li>2.多組車牌號碼將綁定一張或多張特定之信用卡、第三方支付帳戶或其他支付方法（以下合稱「綁定之付款方式」），進行請款處理；會員綁定車號時，即同意授權本服務得依據會員需求，建立會員訂單，並依據會員之消費記錄（支付明細），向會員綁定之付款方式進行請款。</li>
                            <li>3.當綁定的車號進入本公司的服務場域時，本服務將設定訂單產生之時間，而當綁定的車號離開前述場域，本服務將取得訂單完成時間，並即時發送消費記錄（支付明細）至會員 LINE@，該次訂單即視為完成。本服務亦會將歷次會員使用服務的消費記錄(支付明細)，顯示於消費記錄頁面中，會員並可透過本服務隨時查詢，亦可透過設定隨時取消綁定。 </li>
                            <li>4.如您的訂單因任何因素而無法成功由您綁定之付款方式為成功扣款時（以下簡稱「扣款失敗」），本公司將進行以下催繳程序：
                                <div className='subList'>A. 本公司將於知悉該筆訂單扣款失敗時，以電子郵件或 LINE@ 通知之方式書面通知您，並請您盡快綁定其他有效之付款方式，以茲本公司於您變更後之翌日完成扣款。</div>
                                <div className='subList'>B. 本公司向您發出前揭書面通知後 5 日內，您的訂單若仍扣款失敗，本公司將暫停對您提供本服務之全部或任何部分。</div>
                                <div className='subList'>C. 承上，本公司之指定人員將以電子郵件或電話與您聯繫該筆扣款失敗之債務催繳事宜，並將請您於指定期限內清償債務，若未如期繳納，本公司將於前揭期滿之日起按年利率百分之五加收遲延利息。</div>
                            </li>
                          </ol> {/* Construction description */}
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />   */}
                    {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">二、消費記錄與優惠認定</div> {/* Maintenance title */}
                      <div className="text-list">
                        <p>本服務所產生的消費記錄，將依據會員車輛進入合作服務場域的時間，生成訂單編號，會員可依消費記錄了解本身付款狀況。會員所累積之優惠，可於期限內於本服務使用；使用期間之認定，依照本公司伺服器收到訂單完成而送出請款請求之時間為準。若因任何因素（不可抗力除外）造成場域傳送延誤，使得優惠無法使用，本公司概不負責。</p> {/* Maintenance description */}
                      </div>
                    </div>
                  </li>
                  <li>
                    {/* <FaTools className='icon' />  */}
                     {/* Tools icon */}
                    <div className='text'>
                    <div className="policyTitle">三、退費流程與機制</div> {/* Maintenance title */}
                      <div className="text-list">
                        <ol>
                          <li>1. 因不可歸責會員之事由而發生支付錯誤之情況時（例如：車牌號碼、信用卡或帳號等資訊遭盜用，或其他軟硬體之技術問題造成訂單不應產生卻完成支付流程等等）本公司應協助會員進行更正，並提供必要之協助，且得視具體情況先行停止交易或凍結會員帳號之使用。</li>
                          <li>2. 因可歸責於本公司之事由而發生支付錯誤之情況時，本公司將於知悉時進行即時更正，並以電子郵件之方式向會員進行通知。</li>
                          <li>3. 因可歸責於會員之事由而發生支付錯誤之情況時，會員有即時通知本公司之義務，本公司將於知悉後協助會員進行必要之處理。</li>
                        </ol> {/* Maintenance description */}
                      </div>
                    </div>
                  </li>
                </ul>
                <Button link={'About-us'} title={'learn more'} /> {/* About-Us Button */}
              </div>

            </div>
          
        </section>

      </section>
    </>
  );
}

export default RefundPolicy;